<template>
  <div class="school-container">
    <div class="school-content">
      <div class="tabs">
        <div class="tab-group">
          <div class="breadcrumb">课程分类 &gt;</div>

          <span
              v-for="tab in mainTabs"
              :key="tab.id"
              class="tab"
              :class="{ active: activeMainTab === tab.id }"
              @click="selectMainTab(tab.id)">
            {{ tab.typeName }}
          </span>
<!--          <span
            v-for="tab in mainTabs"
            :key="tab.id"
            class="tab"
            :class="{ active: tab.id === activeMainTab }"
            @click="selectMainTab(tab.id)"
          >{{ tab.name }}</span>-->
        </div>
        <div v-if="subTabsMap[activeMainTab]" class="tab-subgroup">

          <span
              v-for="sub in subTabsMap[activeMainTab]"
              :key="sub.id"
              :class="{ active: activeSubTab === sub.id }"
              class="tab-sub"
              @click="selectSubTab(sub.id)">
            {{ sub.typeName }}
          </span>
<!--          <span
            v-for="sub in subTabsMap[activeMainTab]"
            :key="sub.id"
            class="tab-sub"
            :class="{ active: sub.id === activeSubTab }"
            @click="selectSubTab(sub.id)"
          >{{ sub.name }}</span>-->
        </div>
      </div>

      <div class="course-list">
        <div v-for="course in courses"
             :key="course.id"
             class="course-card">
            
             <div class="course-img" @click="playVideo(course)">  
<!--      style="height: 48px; width: 48px; object-fit: cover; cursor: pointer;"      -->
            <img :src="course.picture" alt="课程图片" style="height: 100%; width: 100%; object-fit: cover; cursor: pointer;" />
          </div>
          <div class="course-info">
            <div class="course-title">{{ course.title }}</div>
            <div class="course-meta">
              <span v-show="course.price!=null" class="price"><span class="vip">会员专享</span> {{ course.price*0.6 }} <span class="origin">￥{{ course.price }}</span></span>

              <div v-show="course.price==null" class="course-action">
                <span class="date">{{publishedDateShow(course.publishedDate)}}</span>
              </div>
              <span v-show="course.price!=null" class="views"><svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8 3C4 3 1.333 8 1.333 8C1.333 8 4 13 8 13C12 13 14.667 8 14.667 8C14.667 8 12 3 8 3Z" stroke="#B3B3B3" stroke-width="1.2"/>
                <circle cx="8" cy="8" r="2.2" stroke="#B3B3B3" stroke-width="1.2"/></svg> {{ course.views }}</span>
              <span class="views2" v-show="course.publishedDate!=null">
                <span>立即报名</span>

              </span>
            </div>

          </div>
        </div>
        </div>
      <MyPagination
          v-show="pagination.total>0"
          :total="pagination.total"
          v-model:page="pagination.pageNum"
          v-model:limit="pagination.pageSize"
          @pagination="getList"
      />
      </div>
    </div>
    <div class="play-video-container">
      <video
        v-if="videoUrl"
        :src="videoUrl"
        controls
        autoplay
        style="width: 100%; max-width: 800px; margin: 40px auto; display: block;"
      ></video>
    </div>

</template>

<script setup>
import {ref, onMounted} from 'vue'
import {getGrateOne, getSubTypes, getCoursesByType, getMyClass, checkWatch} from '@/api/video'
import { useRouter } from 'vue-router'
import MyPagination from '@/components/MyPagination/MyPagination.vue'

// 一级标签
const mainTabs = ref([])

// 二级标签：map 结构，key 是一级标签 id，value 是二级标签数组
const subTabsMap = ref({})

// 当前选中的一级和二级标签
const activeMainTab = ref(null)
const activeSubTab = ref(null)

// 新增：是否正在查看“我能观看”
const isViewingMyClass = ref(false)
// 课程列表
const courses = ref([])

// 分页
const pagination = ref({
  pageNum: 1,
  pageSize: 16,
  total: 0
})

// 定义一个新对象，结构与您提供的字段一致
const newTab = {
  deleted: 0,
  id: -1,
  parentId: 0,
  remark: "我能观看",
  sort: null, // 排序值可根据需要设置
  videoGrade: 1,
  status: 0,
  typeName: "我能观看",
  updateAdminId: null,
  updateBy: null,
  updateTime: null,
  updatedDate: null,
  backup1: null,
  createAdminId: null,
  createBy: null,
  createTime: null,
  createdDate: null
}

// ✅ 方法：格式化为 "x月x日开课"
const publishedDateShow = (dateStr) => {
  if (!dateStr) return ''

  // 解析日期字符串
  const date = new Date(dateStr)
  const month = date.getMonth() + 1 // 月份从0开始，需+1
  const day = date.getDate()

  return `${month}月${day}日开课`
}
// 加载某个一级标签下的二级标签
const loadSubTabs = (parentId) => {
  // 如果已经加载过，不再重复请求
  if (subTabsMap.value[parentId]) {
    activeSubTab.value = subTabsMap.value[parentId][0]?.id || null
    loadCourses(activeSubTab.value)
    return
  }
  getSubTypes(parentId,0)
      .then(res => {
        const subList = res.rows || []
        // 添加“全部”选项
        const fullList = [
          { id: 0, typeName: '全部', parentId }
        ].concat(subList)

        // 存入 map
        subTabsMap.value[parentId] = fullList

        // 默认选中“全部”
        activeSubTab.value = fullList[0].id
        // 加载课程
        loadCourses(activeSubTab.value)
      })
      .catch(err => {
        console.error(`获取二级标签失败 (parentId: ${parentId}):`, err)
      })
}

// 根据 typeId 加载课程
const loadCourses = (typeId) => {
  let params = {
    pageNum: pagination.value.pageNum,
    pageSize: pagination.value.pageSize,
  }
  // 如果 typeId 是 0（“全部”），则按 parentId 查询
  // 否则按具体 typeId 查询
  if (typeId === 0) {

    params.parentId = activeMainTab.value // 查询该一级分类下的所有视频,parentId为一级标签的id{2，3，4}
    pagination.value.parentId = activeMainTab.value
    activeSubTab.value = 0
  } else {
    params.typeId = typeId
    pagination.value.typeId = typeId
  }
  getCoursesByType(params)
      .then(res => {
        courses.value = res.rows || []
        pagination.value.total = res.total
      })
      .catch(err => {
        console.error('获取课程列表失败:', err)
      })

}
const router = useRouter()

onMounted(() => {
  // 获取一级标签（videoGrade = 1）
  getGrateOne(1,0)
      .then(res => {
        mainTabs.value = res.rows || []
        // ✅ 向数组末尾添加这个对象(我能观看)
        mainTabs.value.push(newTab)


        // 默认选中第一个
        if (mainTabs.value.length > 0) {
          activeMainTab.value = mainTabs.value[0].id
          // 加载对应的二级标签
          loadSubTabs(activeMainTab.value)
        }
      })
      .catch(err => {
        console.error('获取一级标签失败:', err)
      })
})


// 切换一级标签
const selectMainTab = (tabId) => {
  activeMainTab.value = tabId


  //查询所有的自己可以看的，已经购买的视频
  if(tabId==-1){

    //我能观看模式
    isViewingMyClass.value = true
    //TODO:在这里添加权限属性
//获取了username，通过username查询所有的数据并展示在一个集合中
     const username = localStorage.getItem('username');
    let params = {
      pageNum: pagination.value.pageNum,
      pageSize: pagination.value.pageSize,
      username:username
    }
     getMyClass(params).then(res=>{
       courses.value = res.rows || []
       pagination.value.total = res.total
     })
  }else{
    isViewingMyClass.value = false // 普通分类
    // 检查是否已加载二级标签
    if (!subTabsMap.value[tabId]) {
      loadSubTabs(tabId)
    } else {
      activeSubTab.value = subTabsMap.value[tabId][0]?.id || null
      let num = subTabsMap.value[tabId][0]?.id  //|| null
      loadCourses(num)
    }
  }
}
/*  */
// 切换二级标签
const selectSubTab = (subTabId) => {
  if (isViewingMyClass.value) return
  activeSubTab.value = subTabId

  // 更新 pagination
  if (subTabId === 0) {
    pagination.value.parentId = activeMainTab.value
    delete pagination.value.typeId
  } else {
    pagination.value.typeId = subTabId
    delete pagination.value.parentId
  }

  // 重置页码并加载
  pagination.value.pageNum = 1
  getList()
}

/** 查询视频管理列表 */
function getList() {
  const params = {
    pageNum: pagination.value.pageNum,
    pageSize: pagination.value.pageSize
  }
  if (isViewingMyClass.value) {
    // 当前是“我能观看”模式
    const username = localStorage.getItem('username')
    params.username = username

    getMyClass(params)
        .then(res => {
          courses.value = res.rows || []
          pagination.value.total = res.total
        })
        .catch(err => {
          console.error('获取“我能观看”课程失败:', err)
        })
  } else {
    // 如果是“全部”，按 parentId 查询
    if (pagination.value.typeId === 0 || !pagination.value.typeId) {
      params.parentId = activeMainTab.value
    } else {
      params.typeId = pagination.value.typeId
    }
    getCoursesByType(params)
        .then(res => {
          courses.value = res.rows || []
          pagination.value.total = res.total
        })
        .catch(err => {
          console.error('获取课程列表失败:', err)
        })
  }
}

const videoUrl = ref('')

// 点击课程图片播放视频
function playVideo(course) {
  const token = localStorage.getItem('token')
  const username = localStorage.getItem('username')
  console.log(course)
  //传入数据得到能不能观看
  const params={
    username:username,
    categoryId:course.categoryId,
    id:course.id
  }
  //后端需要通过传入的categoryId得到一级标签是哪一个，如果是免费视频，返回true，
  // 如果不是免费课程，再查看二级标签id和用户名在权限表中是否存在存在返回true，不存在返回 false
  checkWatch(params).then(res=>{
    console.log(res)
    if(res.code ===200){
      if (!token) {
        router.push({ path: '/login' })
      } else {
        router.push({
          name: 'VideoPlayer',
          query: {
            url: encodeURIComponent(course.videoUrl),
            title: course.title
          }
        })
      }
    }else if(res.code ===300){
      alert(res.msg)

    }else if(res.code ===203){
      alert(res.msg)

    }
  })

}
</script>

<style scoped>
.school-container {
  min-height: 100vh;
  background: #f6fbff;
  display: flex;
  flex-direction: column;
}
.navbar {
  position: relative;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 48px;
  background: linear-gradient(90deg, #0a183c 60%, #1e3c72 100%);
  z-index: 10;
  box-sizing: border-box;
}
.logo {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1.5px;
  margin-left: 100px; 
}
.nav-links {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  margin-right: 100px;
}
.nav-links li {
  margin-left: 18px;
}
.nav-links a {
  color: #fff;
  text-decoration: none;
  font-size: 15px;
  transition: color 0.2s;
}
.nav-links a.active,
.nav-links a.router-link-exact-active {
  color: #00e0ff;
  font-weight: bold;
}
.nav-links a:hover {
  color: #00e0ff;
}
.auth-links {
  display: flex;
  align-items: center;
}
.divider {
  margin: 0 6px;
  color: #fff;
}
.school-content {
  min-width: calc(4 * 280px + 3 * 12px + 2 * 18px);
  width: fit-content;
  max-width: 100%; /* 防止在小屏幕上溢出 */
  margin: 24px auto 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.04);
  padding: 18px 18px 24px 18px;

  /* 关键：允许容器收缩包裹内容 */
  overflow: hidden; /* 可选：防止阴影溢出圆角 */
}
.breadcrumb {
  color: #888;
  font-size: 14px;
  margin-bottom: 12px;
}
.breadcrumb .active {
  color: #0a183c;
  font-weight: bold;
}
.tabs {
  margin-bottom: 18px;
}
.tab-group {
  display: flex;
  gap: 12px;
  margin-bottom: 6px;
}
.tab {
  padding: 4px 14px;
  border-radius: 14px;
  background: #f2f6fa;
  color: #333;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.tab.active {
  background: #0a183c;
  color: #fff;
}
.tab-subgroup {
  display: flex;
  gap: 8px;
}
.tab-sub {
  padding: 2px 8px;
  border-radius: 8px;
  background: #f2f6fa;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.tab-sub.active {
  background: #e0f7ff;
  color: #0a183c;
  font-weight: bold;
}
.course-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px 12px;
  margin-top: 10px;
}
.course-card {
  background: #f8fbff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.03);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s;
  border: 1px solid #e6f0fa;
}
.course-card:hover {
  box-shadow: 0 6px 24px rgba(0,64,128,0.08);
}
.course-img {
  height: 185px;
  background: #ddefff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-placeholder {
  color: #7bb1e6;
  font-size: 14px;
}
.course-info {
  padding: 10px 8px 8px 8px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.course-title {
  width: 60%;
  font-size: 13px;
  font-weight: bold;
  color: #222;
  margin-bottom: 4px;
  text-align: left;
}
.course-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #888;
  margin-bottom: 4px;
}
.price {
  color: #ff7e00;
  font-weight: bold;
}
.price .vip {
  background: #ffe6b3;
  color: #ff7e00;
  border-radius: 6px;
  padding: 1px 4px;
  font-size: 10px;
  margin-right: 2px;
}
.price .origin {
  color: #bbb;
  text-decoration: line-through;
  font-size: 11px;
  margin-left: 2px;
}
.views {
  display: flex;
  align-items: center;
  gap: 2px;
}
.views2 {
  /* 设置背景颜色为橙色 */
  background-color: #FF7F00;

  /* 设置文本颜色为白色 */
  color: white;
  letter-spacing: 3px;
  /* 设置字体大小 */
  font-size: 10px;

  /* 设置字体加粗 */
  font-weight: bold;

  /* 设置内边距（上下左右各8px） */
  padding: 3px 5px;

  /* 设置圆角 */
  border-radius: 4px;

  /* 去除默认的边框 */
  border: none;

  /* 设置鼠标悬停时的效果 */
  cursor: pointer;
  transition: background-color 0.3s ease;

  /* 鼠标悬停时改变背景颜色 */
  &:hover {
    background-color: #FF9933;
  }
}
.course-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
}
.date {
  color: #FF7F00;;
}
.btn-order {
  background: #258aff;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 2px 10px;
  cursor: pointer;
  font-size: 12px;
  transition: background 0.2s;
}
.btn-order:hover {
  background: #0a183c;
}
@media (max-width: 900px) {
  .course-list {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .navbar {
    flex-direction: column;
    height: auto;
    padding: 8px 8px;
  }
  .nav-links {
    flex-direction: column;
    width: 100%;
  }
  .nav-links li {
    margin: 8px 0 0 0;
  }
  .school-content {
    padding: 8px 4px 12px 4px;
  }
  .course-list {
    grid-template-columns: 1fr;
  }
}
</style> 